import { supabase } from './supabase';

/**
 * Open an EventSource with the current Supabase access token attached as a
 * `?token=...` query parameter, since EventSource cannot set headers.
 *
 * The server (`/api/*` middleware) accepts the token from either the
 * Authorization header or this query param. SSE-only routes use this.
 */
export async function authedEventSource(url: string): Promise<EventSource> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) {
    // No session — return a plain EventSource; the server will 401, and the
    // caller's onerror handler will see it. This keeps behavior predictable
    // when the user signs out mid-stream.
    return new EventSource(url);
  }
  const sep = url.includes('?') ? '&' : '?';
  return new EventSource(`${url}${sep}token=${encodeURIComponent(token)}`);
}
